import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { IconEdit, IconEye } from '@tabler/icons-react';
import docsMutation from '@/api/mutitations/docs';
import prepareTranslate from '@/helpers/dictionary';
import { Text } from '@mantine/core';
import Table from '../Table';
import { extractFilterOptions, filterAndSortData } from '../Table/Table.functions';

function RecurringExpenses(props) {
  const {
    agent,
    id,
    setSelectedExpense,
    openView,
    openEdit,
  } = props;

  const [expenses, setExpenses] = useState([]);
  const [filterOptions, setFilterOptions] = useState({});
  const [columnFilters, setColumnFilters] = useState({});

  const { mutateAsync: exportFileMutate } = docsMutation.useExportFile();
  const t = prepareTranslate();

  useEffect(() => {
    const filtered = (agent?.expenses?.filter((e) => e.status !== 'archive' && e.isRecurring) || [])
      .map((e) => ({ ...e, addedDate: e.addedDate || e.createdAt }));
    setExpenses(filtered);
  }, [agent]);

  const columns = [
    {
      title: 'שם חיוב',
      accessor: 'type',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'סכום',
      accessor: 'value',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'תאריך הוספה',
      accessor: 'addedDate',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
      transforms: [{ func: 'date', params: { withTime: false } }],
    },
    {
      title: 'האם פעיל',
      accessor: 'isRecurringActive',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
      transforms: ['boolean'],
    },
    {
      title: 'הערות',
      accessor: 'comments',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'פעולות',
      actions: [
        {
          title: 'צפייה',
          icon: <IconEye />,
          showLabel: true,
          isPrimary: true,
          action: (_, row) => {
            setSelectedExpense(row);
            openView();
          },
        },
        {
          title: 'עריכה',
          icon: <IconEdit />,
          showLabel: true,
          isPrimary: true,
          action: (_, row) => {
            setSelectedExpense(row);
            openEdit();
          },
        },
      ],
    },
  ];

  useEffect(() => {
    const options = extractFilterOptions(expenses, columns);
    setFilterOptions(options);

    const initialFilters = columns
      .filter((col) => col.accessor)
      .reduce((acc, col) => {
        acc[col.accessor] = '';
        return acc;
      }, {});
    setColumnFilters(initialFilters);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expenses]);

  const getData = async (start, end, query, sort) => {
    const filteredAndSorted = filterAndSortData(expenses, query, sort);

    return {
      data: filteredAndSorted,
      count: filteredAndSorted.length,
    };
  };

  // eslint-disable-next-line consistent-return
  const createFile = async (option, query) => {
    const requestColumns = columns.filter((column) => column.title !== 'פעולות');
    const exportData = {
      query: { ...query, _id: id },
      fileType: option,
      service: 'agent',
      columns: requestColumns,
      titleArray: [''],
      furtherData: {
        select: 'expenses',
      },
    };

    const fileTitleBase = t('components.viewAgentExpenses.fileTitle', [agent.personalDetails.fullName]);
    const fileTitle = option === 'pdf' ? `${fileTitleBase}.pdf` : `${fileTitleBase}.xlsx`;

    try {
      const fileData = await exportFileMutate(exportData);
      return { fileData, fileTitle };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching expenses:', error);
    }
  };

  return (
      <>
          <Text c='var(--mantine-color-brand-5)' fw={'bold'} >חיוב מחזורי</Text>
        <Table
          key={expenses.length}
          columns={columns}
          getData={getData}
          isColumnsActive={false}
          isExportActive={false}
          exportOptions={['excel']}
          columnFilters={columnFilters}
          setColumnFilters={setColumnFilters}
          filterOptions={filterOptions}
          createFile={createFile}
          dynamicRowHeight={true}
        />
    </>
  );
}

RecurringExpenses.propTypes = {
  agent: PropTypes.object,
  id: PropTypes.string,
  setSelectedExpense: PropTypes.func,
  openView: PropTypes.func,
  openEdit: PropTypes.func,
};

export default RecurringExpenses;
